const config = {
  sitecoreApiKey: process.env.SITECORE_API_KEY || "",
  sitecoreApiHost: process.env.SITECORE_API_HOST || "",
  layoutServiceConfigurationName:
    process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || "",
  publicUrl: process.env.PUBLIC_URL || "",
  isEditing: process.env.IS_EDITING === "true",
};

export default config;
